export function removeTooltips() {
  // remove any tooltips outside virtual dom
  const donutChartTooltip = document.querySelector('#chartjs-tooltip');
  if (donutChartTooltip) {
    donutChartTooltip.parentNode.removeChild(donutChartTooltip);
  }
  const yearLineChartTooltip = document.querySelector(
    '#chartjs-tooltip-yearoverview',
  );

  /* istanbul ignore next */
  if (yearLineChartTooltip) {
    yearLineChartTooltip.parentNode.removeChild(yearLineChartTooltip);
  }
}
